import { FineSettingsService } from "./../../../financial-settings/components/fines/fine-settings.service";
import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  Input,
  ViewChild,
} from "@angular/core";
import { FineService } from "../../fine.service";
import { ErrorHandlerService } from "../../../../services/shared/error-handler.service";
import { SlimLoadingBarService } from "ng2-slim-loading-bar";
import { UserServiceService } from "../../../../services/user-service/user-service.service";
import { ReservationService } from "../../../../services/reservation-service/reservation.service";

@Component({
  selector: "app-add-fine-form-modal",
  templateUrl: "./add-fine-form-modal.component.html",
  styleUrls: ["./add-fine-form-modal.component.css"],
})
export class AddFineFormModalComponent implements OnInit {
  @Output() onSave = new EventEmitter();

  @ViewChild("modalRef") modalRef;

  fine_id;

  // -- fetched
  fine_rules = [];
  banks_list = [];
  store_banks_list = [];

  reservation_id = null;
  formData;
  rule_name: string;
  rule_amount: string;
  rule_text: string;

  constructor(
    private fineService: FineService,
    private reservationService: ReservationService,
    private userService: UserServiceService,
    private fineSettingsService: FineSettingsService,
    private errorHandlerService: ErrorHandlerService,
    private slimLoadingBarService: SlimLoadingBarService
  ) {}

  ngOnInit() {
    this.getStoreBanks();
    this.getBanks();
  }

  getBanks() {
    this.reservationService.getbanks().subscribe(
      (res: any) => {
        this.banks_list = res;
      },
      (err) => this.errorHandlerService.handleErorr(err)
    );
  }

  getStoreBanks() {
    this.userService.getBanks().subscribe(
      (data: any) => {
        this.store_banks_list = data;
      },
      (err) => this.errorHandlerService.handleErorr(err)
    );
  }

  public open(reservation_id, project_id, fine) {
    this.reservation_id = reservation_id;
    this.getFineRules(project_id);

    if (fine) {
      this.fine_id = fine.id;
      this.getFine();
    } else {
      this.formData = {
        fine_rule_id: null,
        fine_date: "",
        description: "",
        attachment: null,
        is_warning: false,
      };
    }

    this.modalRef.open();
  }

  getFine() {
    this.fineService.getFine(this.fine_id).subscribe((res) => {
      this.formData = {
        fine_id: res.id,
        fine_rule_id: res.fine_rule_id,
        cheque_number: res.cheque_number,
        bank_id: res.bank_id,
        store_status: +res.store_status,
        description: res.description,
        attachment: null,
        is_warning: res.is_warning,
        rule_name: res.rule_name,
        rule_amount: res.rule_amount,
        rule_text: res.rule_text,
      };
    });
  }

  getFineRules(project_id) {
    this.fine_rules = [];
    this.fineSettingsService.getFines({ project_id }).subscribe((res) => {
      this.fine_rules = res.data;
    });
  }

  handleUploadFile(event) {
    this.formData.attachment = null;
    if (event.target.files && event.target.files.length) {
      let file = event.target.files[0];

      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.formData.attachment = {
          file_name: file.name,
          file_type: file.type,
          file_value: (reader.result as any).split(",")[1],
        };
      };
    }
  }

  save() {
    const payload = { ...this.formData };
    if (payload.fine_rule_id === "other") {
      delete payload.fine_rule_id;
      payload.rule_name = this.rule_name;
      payload.rule_amount = this.rule_amount;
      payload.rule_text = this.rule_text;
    } else {
      delete payload.rule_name;
      delete payload.rule_amount;
      delete payload.rule_text;
    }
    this.slimLoadingBarService.start();
    this.fineService
      .addFine(this.reservation_id, payload)
      .subscribe(
        (res) => {
          this.onSave.emit();
          this.modalRef.close();
        },
        (err) => {
          this.errorHandlerService.handleErorr(err);
        }
      )
      .add(() => {
        this.slimLoadingBarService.complete();
      });
  }

  closeModal() {
    this.fine_id = null;
  }
}



// WEBPACK FOOTER //
// ./src/app/financial/fines-view/modals/add-fine-form-modal/add-fine-form-modal.component.ts